<script lang="ts">
  import { onMount } from "svelte";

  export let stroke: number = 6;
  export let progress: number = 0;
  export let duration: string = "0.5s";
  export let showTrack: boolean = true;
  export let trackColor: string = "text-indigo-100";
  export let progressColor: string = "text-indigo-800";
  export let lineCap: "butt" | "inherit" | "round" | "square" = "butt";
  export let easing: string = "ease-out";

  const width = 64;

  $: radius = (width - stroke) / 2;
  $: centerPoint = width / 2;
  let initialRendered: boolean = false;

  $: dasharray = 2 * radius * Math.PI;
  $: dashoffset = initialRendered ? 2 * radius * Math.PI * (1 - progress) : dasharray;

  onMount(() => {
    setTimeout(() => {
      initialRendered = true;
    }, 100);
  });
</script>

<div class={"relative aspect-square " + $$restProps.class}>
  <svg class="w-full h-full" viewBox="0 0 {width} {width}">
    {#if showTrack}
      <circle
        class={trackColor}
        stroke-width={stroke}
        stroke="currentColor"
        fill="transparent"
        r={radius}
        cx={centerPoint}
        cy={centerPoint}
      />
    {/if}
    <circle
      class="{progressColor} origin-center -rotate-90"
      style="transition: stroke-dashoffset; transition-duration: {duration}; transition-timing-function: {easing}"
      stroke-width={stroke}
      stroke-dasharray={dasharray}
      stroke-dashoffset={dashoffset}
      stroke-linecap={lineCap}
      stroke="currentColor"
      fill="transparent"
      r={radius}
      cx={centerPoint}
      cy={centerPoint}
    />
  </svg>
  <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
    <slot {progress} percent={Math.round(progress * 100)} />
  </div>
</div>
